import dayjs from 'dayjs'

export const tryOnce = (key: string, cb: Function, unit: number, manipulateType: dayjs.ManipulateType) => {
  key = 'try:' + key
  const lastTry = dayjs(localStorage.getItem(key) || 0)
  if (lastTry.add(unit, manipulateType).isBefore(dayjs())) {
    cb()
    localStorage.setItem(key, dayjs().toString())
  }
}
